import React from "react";
import { SectionShell, Field } from "./PartnerFormPrimitives";
import { US_STATES } from "./partnerConstants";

export default function PartnerCompanyContact({ data, set }) {
  return (
    <SectionShell
      index={1}
      title="Company & Contact"
      subtitle="Tell us who you are and how to reach you."
      testId="partner-section-company"
    >
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Company Name" required>
          <input className="input-br" value={data.company_name} onChange={set("company_name")} required data-testid="partner-company-name" />
        </Field>
        <Field label="DBA / Trade Name">
          <input className="input-br" value={data.dba_trade_name} onChange={set("dba_trade_name")} />
        </Field>

        <Field label="Contact First Name" required>
          <input className="input-br" value={data.contact_first_name} onChange={set("contact_first_name")} required />
        </Field>
        <Field label="Contact Middle Name">
          <input className="input-br" value={data.contact_middle_name} onChange={set("contact_middle_name")} />
        </Field>
        <Field label="Contact Last Name" required>
          <input className="input-br" value={data.contact_last_name} onChange={set("contact_last_name")} required />
        </Field>
        <Field label="Role / Title">
          <input className="input-br" value={data.role_title} onChange={set("role_title")} placeholder="Owner, Estimator, PM..." />
        </Field>

        <Field label="Phone" required hint="e.g. (512) 555-1234">
          <input className="input-br" value={data.phone} onChange={set("phone")} required />
        </Field>
        <Field label="Email" required>
          <input type="email" className="input-br" value={data.email} onChange={set("email")} required />
        </Field>

        <Field label="Website" className="sm:col-span-2">
          <input className="input-br" value={data.website_url} onChange={set("website_url")} placeholder="https://..." />
        </Field>
      </div>

      <div className="mt-2">
        <div className="label-br">Business Address <span className="text-br-bronze">*</span></div>
        <div className="grid gap-3">
          <input className="input-br" placeholder="Street Address" value={data.business_street1} onChange={set("business_street1")} required />
          <input className="input-br" placeholder="Street Address Line 2 (optional)" value={data.business_street2} onChange={set("business_street2")} />
          <div className="grid sm:grid-cols-4 gap-3">
            <input className="input-br sm:col-span-2" placeholder="City" value={data.business_city} onChange={set("business_city")} required />
            <select className="select-br" value={data.business_state} onChange={set("business_state")} required>
              <option value="">State</option>
              {US_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
            <input className="input-br" placeholder="ZIP" value={data.business_zip} onChange={set("business_zip")} required />
          </div>
        </div>
      </div>

      <Field label="Company ID / Vendor Number" hint="Optional internal reference">
        <input className="input-br" value={data.company_id_vendor_number} onChange={set("company_id_vendor_number")} />
      </Field>
    </SectionShell>
  );
}
